import React from 'react';
import { Tab } from 'semantic-ui-react';
import UploadContainer from './uploadImg';
import { useTranslation } from 'react-i18next';
import OrganizationGallery from './gallery';
import UnsplashGallery from './unsplash';
import { Icon, Modal, Button } from '@weezevent/nacre';

const GalleryModal = ({
    isOpenModal,
    onClose,
    organization,
    isBanner = false,
    customTabs,
    fileType = 'image',
    apiKeyUnsplash = null,
    fileErrors = [],
    setFileErrors,
    maxSize = 2097152,
    ...props
}) => {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = React.useState(0);

    const handleTabChange = React.useCallback(
        (e, { activeIndex }) => {
            setActiveIndex(activeIndex);
        },
        [setActiveIndex]
    );

    const errors = {
        'file-invalid-type': t('ticket.event.dropzone_error_file_invalid_type'),
        'file-too-large': t('ticket.event.dropzone_error_file_too_large', { maxSize: Math.trunc(maxSize / 1000000) }),
        'file-too-small': t('ticket.event.dropzone_error_file_too_small'),
        'too-many-files': t('ticket.event.dropzone_error_too_many_files')
    };

    const panes = [
        {
            menuItem: { key: 'image-upload', icon: <Icon name="image-upload" />, content: t(`ticket.event.minisite.gallery.${fileType}s`) },
            // eslint-disable-next-line react/display-name
            render: () => (
                <div className="wz-tab-content">
                    <UploadContainer
                        {...props}
                        onClose={onClose}
                        organization={organization}
                        isBanner={isBanner}
                        fileType={fileType}
                        {...(isBanner && {
                            cropModalProps: {
                                ratio: 16 / 9,
                                forceRatio: true
                            }
                        })}
                        errors={errors}
                    />
                    <OrganizationGallery organization={organization} fileType={fileType} onClick={() => setActiveIndex(1)} isBanner={Boolean(isBanner)} {...props} />
                </div>
            )
        }
    ];
    if (fileType === 'image' && apiKeyUnsplash) {
        panes.push({
            menuItem: { key: 'public-images', icon: <Icon name="images" />, content: t(['ticket.event.minisite.public-images']) },
            // eslint-disable-next-line react/display-name
            render: () => (
                <div className="wz-tab-content">
                    <UnsplashGallery organization={organization} isBanner={isBanner} apiKeyUnsplash={apiKeyUnsplash} {...props} />
                </div>
            )
        });
        if (customTabs) {
            customTabs.forEach(customTab => {
                panes.push({
                    menuItem: { icon: <Icon name={customTab.icon} />, content: customTab.content },
                    // eslint-disable-next-line react/display-name
                    render: () => <div className="wz-tab-content">{customTab.children}</div>
                });
            });
        }
    }

    return (
        <Modal
            className="gallery-modal"
            size="large"
            open={Boolean(isOpenModal)}
            allowExternalClosing={false}
            onClose={onClose}
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.close')} />}
        >
            <Tab className="wz-image-gallery" menu={{ secondary: true, pointing: true }} panes={panes} onTabChange={handleTabChange} activeIndex={activeIndex} />
        </Modal>
    );
};

export default GalleryModal;
